import Drawer from "@mui/material/Drawer";
import { DashboardCustomizeRounded as DashboardCustomizeRoundedIcon } from "@mui/icons-material";
import { ChevronRightRounded as ChevronRightRoundedIcon } from "@mui/icons-material";
import { Room as RoomIcon } from "@mui/icons-material";
import { Policy as PolicyIcon } from "@mui/icons-material";
import { Logout as LogoutIcon } from "@mui/icons-material";
import { AdminPanelSettings as AdminPanelSettingsIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Description as DescriptionIcon } from "@mui/icons-material";
import "./RightDrawer.scss";
// import { useSelector } from "react-redux";
import AvatarGenerator from "../profilePic/GenerateAvatar";
import { useEffect, useState } from "react";
import { logoutAction } from "../../store/actions/authAction";
import { APPROLES } from "../../utils/Constants";
import { isMobile } from "react-device-detect";
import { Gavel as GavelIcon } from "@mui/icons-material";
import { Payments as PaymentsIcon } from "@mui/icons-material";
import { LocalLibrary as LocalLibraryIcon } from "@mui/icons-material";
import { emptyCartAction } from "../../store/actions/cartAction";
import { Box, Typography } from "@mui/material";
import { Contacts as ContactsIcon } from "@mui/icons-material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { Person as PersonIcon } from "@mui/icons-material";
import { DownloadForOffline as DownloadForOfflineIcon } from "@mui/icons-material";
import ConfirmLogoutModal from "../modal/ConformLogoutModel";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import ImageView from "../ImageView/ImageView";
function RightDrawer(props: any) {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  var { userInfo } = useSelector((state: any) => state.user);
  const personalInfo = userInfo?.personalInfo;

  const ppUrl = personalInfo?.profilePictureUrl || "";
  const userFName = personalInfo?.firstName || "";
  const userLName = personalInfo?.lastName || "";
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isLogoutConfirmModalOpen, setIsLogoutConfirmModalOpen] =
    useState(false);

  useEffect(() => {
    if (
      userInfo &&
      (userInfo.userType === APPROLES.SUPERADMIN.roleId ||
        userInfo.userType === APPROLES.ADMIN.roleId)
    ) {
      setIsSuperAdmin(true);
    }
  }, [userInfo]);

  const navigateToPage = (navId: string) => {
    props.setOpenRightSidePanel(false);
    navigate(navId);
  };

  const handleLogout = (event: any) => {
    event.preventDefault();
    dispatch(emptyCartAction());
    dispatch(logoutAction());
    navigate("/");
    props.setOpenRightSidePanel(false);
    setIsLogoutConfirmModalOpen(false);
  };
  const handleCancelLogout = () => {
    setIsLogoutConfirmModalOpen(false);
  };
  
  const getExternalAdminOnlyView = () => {
    if (userInfo && (userInfo?.userType === APPROLES.BLOGADMIN.roleId )) {
      return (
        <li
          onClick={() => {
            if(userInfo?.userType === APPROLES.BLOGADMIN.roleId){
              navigateToPage("/admin/externaladmin/posts");
            }
            
          }}
        >
          <a href="javascript:void(0)">
            <DescriptionIcon />
            External Admin
          </a>
        </li>
      );
    }

    return null;
  };
  return (
    <Drawer
      anchor={"right"}
      open={props.openRightSidePanel}
      onClose={() => props.setOpenRightSidePanel(false)}
    >
      <div className="rightPannelArea">
        {userInfo ? (
          <div
            className="pannelTop"
            onClick={() => {
              if (isMobile) {
                navigateToPage("/profile/");
              } else {
                navigateToPage("/profile/personalInfo");
              }
            }}
          >
            <div className="leftProfileInfo">
              {ppUrl ? (
                <Box className="leftProfileImg">
                  <ImageView src={ppUrl} alt="User Profile Image" />
                </Box>
              ) : (
                <AvatarGenerator firstName={userFName} lastName={userLName} />
              )}
              <h6>
                {userFName} {userLName}{" "}
                <p>{t(LOCALIZATION.View_and_edit_profile)}</p>{" "}
              </h6>
            </div>
            <div className="rightArrow">
              <button>
                <ChevronRightRoundedIcon />
              </button>
            </div>
          </div>
        ) : (
          <div
            className="pannelTop"
            onClick={() => {
              if (isMobile) {
                navigateToPage("/login");
              } else {
                navigateToPage("/login");
              }
            }}
          >
            <div className="leftProfileInfo">
              <AccountCircleRoundedIcon />

              <h6>{t(LOCALIZATION.Login_OR_Sign_up)}</h6>
            </div>
            <div className="rightArrow">
              <button>
                <ChevronRightRoundedIcon />
              </button>
            </div>
          </div>
        )}

        <div className="bottomMenuList1">
          <ul>
            {/* <li>
              <a href="#">
                <CategoryRoundedIcon />
                Categories
              </a>
            </li> */}
            {userInfo ? (
              <li onClick={() => navigateToPage("/myOrders")}>
                <a href="javascript:void(0)">
                  <DashboardCustomizeRoundedIcon />
                  {t(LOCALIZATION.My_Orders)}
                </a>
              </li>
            ) : null}
            {userInfo ? (
              <li onClick={() => navigateToPage("/profile/address")}>
                <a href="javascript:void(0)">
                  <RoomIcon />
                  {t(LOCALIZATION.Address)}
                </a>
              </li>
            ) : null}

            {isSuperAdmin && (
              <li
                onClick={() => {
                  navigateToPage("/admin");
                }}
                style={{ cursor: "pointer" }}
              >
                {/* <a href="javascript:void(0)"> */}
                <AdminPanelSettingsIcon />
                {t(LOCALIZATION.Admin_Panel)}
                {/* </a> */}
              </li>
            )}
            {getExternalAdminOnlyView()}
            <Box className="forMobileOnly">
              <li>
                <a href="/about">
                  <PersonIcon />
                  {t(LOCALIZATION.About_Us)}
                </a>
              </li>

              <li>
                <a href="/refundscancellations">
                  <PaymentsIcon />
                  {t(LOCALIZATION.Refunds_and_Cancellations)}
                </a>
              </li>

              <li>
                <a href="/communityguidelines">
                  <LocalLibraryIcon />
                  {t(LOCALIZATION.Content_Community_Guidlines)}
                </a>
              </li>

              <li>
                <a href="/privacypolicy">
                  <PolicyIcon />
                  {t(LOCALIZATION.Privacy_Policy)}
                </a>
              </li>
              <li>
                <a href="/termsandconditions">
                  <GavelIcon />
                  {t(LOCALIZATION.Terms_and_Conditions)}
                </a>
              </li>

              <li>
                <a href="/contactus">
                  <ContactsIcon />
                  {t(LOCALIZATION.Contact_Us)}
                </a>
              </li>
            </Box>
            {/* {isSuperAdmin && (
              <li
                onClick={() => {
                  navigateToPage("/admin/useranalytics");
                }}
              >
                <a href="javascript:void(0)">
                  <AnalyticsIcon />
                  User Analytics
                </a>
              </li>
            )}
            {isSuperAdmin && (
              <li
                onClick={() => {
                  navigateToPage("/admin/sendpush");
                }}
              >
                <a href="javascript:void(0)">
                  <NotificationAddIcon />
                  Send Push Notification
                </a>
              </li>
            )}
            {isSuperAdmin && (
              <li
                onClick={() => {
                  navigateToPage("/admin/couponcode");
                }}
              >
                <a href="javascript:void(0)">
                  <ConfirmationNumberIcon />
                  Manage Coupon Code
                </a>
              </li>
            )} */}
          </ul>
        </div>

        <Box className="appDownloadInfo">
          <li>
            <a href="/apps" className="downloadBtnText" target="_blank">
              <DownloadForOfflineIcon />
              <Typography>{t(LOCALIZATION.Download_App)}</Typography>
            </a>
          </li>
        </Box>

        {userInfo ? (
          <div
            className="logOutBtn"
            onClick={() => setIsLogoutConfirmModalOpen(true)}
          >
            <ul>
              <li>
                <a>
                  <LogoutIcon />
                  {t(LOCALIZATION.Logout)}
                </a>
              </li>
            </ul>
          </div>
        ) : null}
      </div>

      <ConfirmLogoutModal
        open={isLogoutConfirmModalOpen}
        onConfirm={handleLogout}
        onCancel={handleCancelLogout}
      />
    </Drawer>
  );
}

export default RightDrawer;
